export class EmissionRequestParams {
    profile: {body, profileName, profile};

    constructor(params, calculatorName, categoryName, currentCalculatorName) {
        this.profile = {
            body: [{
                category: calculatorName,
                class: categoryName,
                input: [params]
            }],
            profileName: `${calculatorName} ${categoryName}`,
            profile: currentCalculatorName
        };
    }
}



// WEBPACK FOOTER //
// ./src/app/models/emissionRequestParams.ts